interface Action<T extends string> {
  (): { type: T };
}

interface ActionWithPayload<T extends string, P> {
  (payload: P): {
    type: T;
    payload: P;
  };
}

const createAction =
  <T extends string>(type: T): Action<T> =>
  () => ({
    type,
  });

const createActionWithPayload =
  <T extends string, P>(type: T): ActionWithPayload<T, P> =>
  (payload: P) => ({
    type,
    payload,
  });

export { createAction, createActionWithPayload };
